// Mismo orden que EmailLabel::COLORS en el backend — no hace falta que
// coincida el índice exacto, sólo que cada nombre de color tenga clases.
const COLOR_CLASSES = {
    slate:  'bg-slate-100 text-slate-700 dark:bg-slate-700/40 dark:text-slate-300',
    red:    'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300',
    orange: 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-300',
    amber:  'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
    green:  'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300',
    blue:   'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
    violet: 'bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-300',
    pink:   'bg-pink-100 text-pink-700 dark:bg-pink-900/30 dark:text-pink-300',
};

export function labelColorClasses(color) {
    return COLOR_CLASSES[color] || COLOR_CLASSES.slate;
}

export default function LabelChip({ label, onRemove, onClick, active = false }) {
    const Tag = onClick ? 'button' : 'span';

    return (
        <Tag
            onClick={onClick}
            className={`inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full ${labelColorClasses(label.color)} ${active ? 'ring-2 ring-offset-1 ring-current' : ''} ${onClick ? 'cursor-pointer' : ''}`}
        >
            {label.name}
            {onRemove && (
                <span
                    onClick={(e) => { e.stopPropagation(); onRemove(); }}
                    className="material-symbols-outlined text-[13px] leading-none hover:opacity-70 cursor-pointer"
                >
                    close
                </span>
            )}
        </Tag>
    );
}
